import { render, staticRenderFns } from "./viewRequest.vue?vue&type=template&id=0b11fd60&scoped=true"
import script from "./viewRequest.vue?vue&type=script&lang=js"
export * from "./viewRequest.vue?vue&type=script&lang=js"
import style0 from "./viewRequest.vue?vue&type=style&index=0&id=0b11fd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11fd60",
  null
  
)

export default component.exports